"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var reactstrap_1 = require("reactstrap");
var Util_1 = require("../../../../../Services/Util");
var CopyText = /** @class */ (function (_super) {
    __extends(CopyText, _super);
    function CopyText(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = function () {
            if (_this.state.tooltipOpen) {
                setTimeout(function () { return _this.setState({ tooltipOpen: false }); }, 500);
            }
        };
        _this.doCopy = function () {
            Util_1.copyText(_this.props.copyTarget);
            _this.setState(function (prevState) { return ({ tooltipOpen: true }); });
        };
        _this.state = {
            tooltipOpen: false
        };
        _this.tooltipTargetRef = React.createRef();
        return _this;
    }
    CopyText.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("div", { style: { cursor: "pointer" }, ref: this.tooltipTargetRef, onClick: this.doCopy },
                React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCopy })),
            React.createElement(reactstrap_1.Tooltip, { placement: "top", isOpen: this.state.tooltipOpen, target: this.tooltipTargetRef, toggle: this.toggle }, this.props.resources.CopiedToClipboard)));
    };
    return CopyText;
}(React.Component));
exports.CopyText = CopyText;
//# sourceMappingURL=CopyText.js.map